export default {
    header: 'History',
}
